import { Grid } from "@mui/material";
import EditAccountTypeDialog from "../dialogs/EditAccountTypeDialog";
import ChangeAccountStatusDialog from "../dialogs/ChangeAccountStatusDialog";
import DeleteAccountDialog from "../dialogs/DeleteAccountDialog";
import ProofDialog from "../dialogs/ProofDialog";
import { dialogTypes, DialogType } from "./data";
import { AdminAccountReportVO } from "../../../../types/admin/AdminAccountReportVO";

interface DialogWrapperProps {
    openDialog: DialogType;
    onCloseDialog: () => void;
    accountBeingActioned: AdminAccountReportVO;
    onEditTypeAction: (account: AdminAccountReportVO) => void;
    onChangeAction: (account: AdminAccountReportVO) => void;
    onDeleteAction: (account: AdminAccountReportVO) => void;
}

const AdminAccountReportDialogs = (props: DialogWrapperProps) => {

    const {openDialog, onCloseDialog, accountBeingActioned, onEditTypeAction, onChangeAction, onDeleteAction} = props;

    const determineOpenDialog = (dialogName: string) => {
        return openDialog.type === dialogName && openDialog.open;
    };

    return <Grid>
        <EditAccountTypeDialog open={determineOpenDialog(dialogTypes.EDIT_TYPE)} onClose={onCloseDialog} account={accountBeingActioned} onEditTypeAction={onEditTypeAction} />
        <ChangeAccountStatusDialog open={determineOpenDialog(dialogTypes.CHANGE_STATUS)} onClose={onCloseDialog} account={accountBeingActioned} onChangeAction={onChangeAction} />
        <DeleteAccountDialog open={determineOpenDialog(dialogTypes.DELETE)} onClose={onCloseDialog} account={accountBeingActioned} onDeleteAction={onDeleteAction} />
        <ProofDialog open={determineOpenDialog(dialogTypes.PROOF_PP) || determineOpenDialog(dialogTypes.PROOF_TOS)} onClose={onCloseDialog} account={accountBeingActioned} type={openDialog.type} />
      </Grid>
}

export default AdminAccountReportDialogs;